import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { combineLatest, map, take, filter } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { VanityRedirectService } from '../services/vanity-redirect.service';
import { TllLoginRedirectService } from '../services/tll-login-redirect.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);
  private readonly vanityRedirect = inject(VanityRedirectService);
  private readonly tllLoginRedirect = inject(TllLoginRedirectService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return combineLatest([this.auth.authReady$, this.auth.isAuthenticated$]).pipe(
      filter(([ready]) => !!ready),
      take(1),
      map(([_, isAuth]) => {
        if (!isAuth) {
          if (this.tllLoginRedirect.shouldRedirectGuestToLogin()) {
            this.tllLoginRedirect.redirectToLogin();
            return false;
          }
          return this.router.parseUrl('/course-catalog');
        }
        if (this.vanityRedirect.maybeRedirect(this.auth.currentUserProfile)) {
          return false;
        }
        return true;
      }),
    );
  }
}
